import React from 'react';
import _ from 'lodash';

import './styles.css';

const SCROLLABLE_COLUMNS = [
  {label: 'Order', className: 'ScrollableTableHeaders__order'},
  {label: 'Room Type', className: 'ScrollableTableHeaders__roomType'},
  {label: 'Room', className: 'ScrollableTableHeaders__room'},
  {label: 'Allocated by', className: 'ScrollableTableHeaders__allocatedBy'},
  {label: 'KYC', className: 'ScrollableTableHeaders__kyc'},
  {label: 'ID', className: 'ScrollableTableHeaders__id'},
  {label: 'Visa', className: 'ScrollableTableHeaders__visa'},
  {
    label: 'Proof of Address',
    className: 'ScrollableTableHeaders__proofOfAddress'
  },
  {label: 'Affordability', className: 'ScrollableTableHeaders__affordability'},
  {label: 'Rent Plan', className: 'ScrollableTableHeaders__rentPlan'},
  {label: 'Agreement', className: 'ScrollableTableHeaders__agreement'},
  {label: 'Balance', className: 'ScrollableTableHeaders__balance'},
  {label: '1st rent paid', className: 'ScrollableTableHeaders__firstRentPaid'},
  {label: 'GC Invite', className: 'ScrollableTableHeaders__goCardless'},
  {label: 'Deposit', className: 'ScrollableTableHeaders__deposit'},
  {
    label: 'Arrival Room Check',
    className: 'ScrollableTableHeaders__arrivalRoomCheck'
  },
  {
    label: 'Departure Room Check',
    className: 'ScrollableTableHeaders__departureRoomCheck'
  },
  {
    label: 'Verification method',
    className: 'ScrollableTableHeaders__verificationMethod'
  },
  {label: 'Notes', className: 'ScrollableTableHeaders__notes'}
];

const ScrollableTableHeaders = () => (
  <div className="ScrollableTableHeaders colab-centered-v">
    {_.map(SCROLLABLE_COLUMNS, column => (
      <div key={column.label} className={column.className}>
        {column.label}
      </div>
    ))}
  </div>
);

export default ScrollableTableHeaders;
